export default class BlobFileItemReader {
  static read(file) {
    return new Promise((resolve, reject) => {
      if (!file.blob) {
        reject(new Error('File has no blob!'));
        return;
      }

      const fr = new FileReader();
      fr.onload = (e) => {
        // eslint-disable-next-line
        file.content = e.target.result;
        resolve(file);
      };
      fr.readAsText(file.blob);
    });
  }
}
